<template>
  <!-- Main Container -->
  <div class="mt-2">
    <b-alert variant="warning" show class="text-center">
      <div>
        <b-icon icon="exclamation-triangle" font-scale="1.5"></b-icon>
        <br>
        Die App befindet sich noch <strong>in Entwicklung</strong>.
        Es können noch vermehrt Fehler auftreten.</div>
    </b-alert>

    <SlideshowView class="mt-5"></SlideshowView>  

    <div>
      <div class="d-flex justify-content-between align-items-center mt-5">
        <h4>Neuigkeiten</h4>
      </div>
      <b-overlay :show="show" rounded="sm">
        <b-card
          v-if="this.news"
          class="text text-align mt-1 mb-1"
          :title="this.news.title"
        >
          <b-card-text>
            <hr />
            {{ this.news.content }}
            <br />
            <br />
            <img v-if="this.news.image" :src="this.news.image" width="100%" alt="News Image" style="border-radius: 0.5rem; max-width: 500px;"/>
          </b-card-text>
        </b-card>
        <b-card v-else no-body class="text-muted bg-light text-center p-3 mt-1 mb-1">
          <div>
            <div><b-icon icon="newspaper" font-scale="1.5"></b-icon></div>
            <p class="mb-0">Keine Neuigkeiten vorhanden</p>
          </div>
        </b-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SlideshowView from "./slideshow/slideshowView.vue";

export default {
  name: "homeView",
  components: {
    SlideshowView
  },
  data() {
    return {
      show: false,

      attendance: null,

      news: null,

      passwordReset: null,

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {},

  mounted() {
    this.show = true;

    /*const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
          icon: "info",
          title:
            "",
        });*/

    axios
      .get(this.apiUrl + "/home/get-informations")
      .then((response) => {
        this.news = response.data.news;

        this.passwordReset = response.data.passwordReset;

        localStorage.setItem('roles', response.data.roles);

        if (response.data.passwordReset === true) {
          this.$swal({
            title: "Bitte ändere dein Passwort",
            text: "Dein Passwort wurde von einem Administrator zurückgesetzt",
            icon: "warning",
            confirmButtonColor: "#B02A2A",
            didClose: () => {
              this.$router.push("/account/security");
            },
          });
        }

        this.show = false;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);

        if (error.status === 401) {
          localStorage.removeItem("token");
        }
      });
  },
};
</script>

<style scoped>
.b-card-body {
  border-radius: 8px;
}

.b-navbar {
  height: 70px;
}

small {
  display: block;
  color: #9b0214;
  text-align: center;
  font-size: 0.8em;
}

a {
  color: #d8041c;
}
</style>
